import BidsApiManager from './BidsApiManager';
import axios from 'axios';

let BASE_URL = process.env.APP_URL;

export default new BidsApiManager(axios, `${BASE_URL}/bids`);



// WEBPACK FOOTER //
// ./src/modules/bids/api/bids.js